import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2Icon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'Guía Paso a Paso',
    desc: 'El protocolo para que tu bebé aprenda a dormirse solo en su cuna.'
  }, {
    title: 'El Reloj Maestro',
    desc: 'Horarios exactos según la edad de tu hijo (3 meses a 2 años).'
  }, {
    title: 'Método de 15 Minutos',
    desc: 'Una rutina de "apagado" rápida para padres con poco tiempo.'
  }, {
    title: 'Guión de Rescate de Noche',
    desc: 'Qué hacer exactamente a las 3 AM para no arruinar el progreso.'
  }, {
    title: 'Auditoría del Hormiguero',
    desc: 'Cómo configurar el cuarto del bebé para que sea un santuario de melatonina.'
  }];
  return <section className="py-24 px-4 bg-navy-800 border-y border-gold/10" data-id="element-33">
      <div className="max-w-5xl mx-auto" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-16 text-center" data-id="element-36">
            Qué Vas a Lograr
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-37">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={0.1 * index} className={index === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-38">
              <div className="bg-navy-900/50 p-8 rounded-2xl h-full border border-gold/10 hover:border-gold/30 transition-colors group" data-id="element-39">
                <CheckCircle2Icon className="w-8 h-8 text-gold mb-6 group-hover:scale-110 transition-transform" data-id="element-40" />
                <h3 className="text-xl font-bold text-cream mb-3 font-serif" data-id="element-41">
                  {benefit.title}
                </h3>
                <p className="text-muted leading-relaxed" data-id="element-42">{benefit.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}